module.exports = __webpack_public_path__ + "static/media/a_of_spades.976fc5f8.png";